"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    ordered,
    values,
    type,
    reversed,
    start
  } = attributes;
  const TagName = ordered ? 'ol' : 'ul';
  return (0, _element.createElement)(TagName, _blockEditor.useBlockProps.save({
    type,
    reversed,
    start
  }), (0, _element.createElement)(_blockEditor.RichText.Content, {
    value: values,
    multiline: "li"
  }));
}
//# sourceMappingURL=save.js.map